const categories = [
    {
      name: 'all',
      text: '전체',
    },
    {
      name: 'vendor',
      text: '점주',
    },
    {
      name: 'clerk',
      text: '점원',
    },
    {
      name: 'admin',
      text: '본사',
    }
];

export default categories;